import { module as Module } from 'modujs'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { html } from '../utils/environment'
import { debounce } from '../utils/tickers'

gsap.registerPlugin(ScrollTrigger)

export default class extends Module {
  constructor(m) {
    super(m)

    this.mm = gsap.matchMedia()
    this.container = this.el
    this.wrapper = this.$('wrapper')[0]
    this.list = this.$('list')[0]
    this.items = this.$('item')
    this.headerHeightRel = getComputedStyle(html).getPropertyValue('--header-height')
    this.headerHeightPx = this.headerHeightRel.replace('rem', '') * 16
  }

  init() {
    this.resize()
    this.initHorizontalScroll()

    const bindResize = this.resize.bind(this)
    const debounceResize = debounce(bindResize, 250)
    window.addEventListener('resize', () => {
      if (html.classList.contains('is-desktop')) {
        debounceResize()
      }
    })
  }

  initHorizontalScroll() {
    let wrapperWidth = this.wrapper.offsetWidth
    let amountScroll = wrapperWidth - window.innerWidth

    window.addEventListener('resize', () => {
      if (html.classList.contains('is-desktop')) {
        wrapperWidth = this.wrapper.offsetWidth
        amountScroll = wrapperWidth - window.innerWidth
      }
    })

    const tweenGallery = gsap.to(this.wrapper, {
      x: () => -amountScroll,
      ease: 'none',
      duration: 3,
    })

    ScrollTrigger.create({
      trigger: this.container,
      start: 'top top',
      end: () => `+=${amountScroll}`,
      pin: true,
      animation: tweenGallery,
      scrub: 1,
      invalidateOnRefresh: true,
    })

    const mobileTrigger = () => {
      const items = gsap.utils.toArray(this.items)

      items.forEach((item) => {
        const { slug } = item.dataset

        ScrollTrigger.create({
          trigger: item,
          start: 'left center',
          end: 'right center',
          scrub: true,
          containerAnimation: tweenGallery,
          onEnter: () => {
            this.call('show', slug, 'PostTitle')
          },
          onLeaveBack: () => {
            this.call('hide', slug, 'PostTitle')
          },
          onEnterBack: () => {
            this.call('show', slug, 'PostTitle')
          },
          onLeave: () => {
            this.call('hide', slug, 'PostTitle')
          },
        })
      })
    }

    if (window.innerWidth < 1200) {
      mobileTrigger()
    }
  }

  checkSize(item) {
    const srcWidth = item.getBoundingClientRect().width
    const srcHeight = item.getBoundingClientRect().height

    const srcRatio = srcWidth / srcHeight

    return srcRatio
  }

  setSizes() {
    this.items.forEach((item) => {
      if (this.checkSize(item) > 1) {
        item.classList.add('-landscape')
      }

      if (this.checkSize(item) < 1) {
        item.classList.add('-portrait')
      }
    })
  }

  setMargin() {
    this.items.forEach((item) => {
      const computedStyle = getComputedStyle(this.list)
      const itemHeight = item.getBoundingClientRect().height
      const listBounding = this.list.getBoundingClientRect()
      const listHeight = listBounding.height - (parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom))

      const maxMarginHeight = listHeight - itemHeight

      item.style.marginTop = `${Math.floor(Math.random() * maxMarginHeight)}px`
    })
  }

  resize() {
    this.setSizes()
    this.setMargin()
    ScrollTrigger.refresh()
  }

  destroy() {
    window.removeEventListener('resize', this.bindResize)
  }
}
